/**
 * Get the role name from the user object.
 * Backend may return user_role as a JSON string (e.g. {"id":1,"name":"Requestor",...})
 * or as an object. This normalizes to the role name string.
 */
export function getRoleName(user: { user_role?: string | { name?: string; [key: string]: unknown } } | null): string | null {
  if (!user?.user_role) return null
  const ur = user.user_role
  if (typeof ur === 'string') {
    try {
      const parsed = JSON.parse(ur) as { name?: string }
      return parsed?.name ?? null
    } catch {
      return ur
    }
  }
  return (ur as { name?: string })?.name ?? null
}

export function isRequestorRole(user: { user_role?: string | { name?: string; [key: string]: unknown } } | null): boolean {
  const name = getRoleName(user)
  return name === 'Requestor' || name === 'requestor'
}
